import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Selection-Slash--Streamline-Flex"
    >
        <desc>
            {'Selection Slash Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="selection-slash">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.498779 0.498535C4.89514 6.13014 7.74866 8.9532 13.501 13.5007"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.01855 13.1978c-0.11704 -0.0127 -0.23363 -0.0257 -0.34974 -0.0388 -0.95975 -0.109 -1.73021 -0.8793 -1.835087 -1.8395 -0.012487 -0.1144 -0.024773 -0.2292 -0.036671 -0.3444"
                strokeWidth={1}
            />
            <path
                id="Intersect_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.513103 7.84588c-0.017471 -0.56801 -0.017471 -1.13054 0 -1.69854"
                strokeWidth={1}
            />
            <path
                id="Intersect_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.9951 0.797241c0.1171 0.012608 0.2337 0.02561 0.3498 0.038796 0.9597 0.108988 1.7302 0.879303 1.835 1.839503 0.0125 0.11433 0.0248 0.22912 0.0367 0.34435"
                strokeWidth={1}
            />
            <path
                id="Intersect_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.4869 7.85296c0.0175 -0.56801 0.0175 -1.13054 0 -1.69854"
                strokeWidth={1}
            />
            <path
                id="Intersect_5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.84649 13.487c-0.56801 0.0175 -1.13054 0.0175 -1.69854 0"
                strokeWidth={1}
            />
            <path
                id="Intersect_6"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.85235 0.513103c-0.56801 -0.017471 -1.13054 -0.017471 -1.69854 0"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
